export default __webpack_public_path__ + "static/media/SSLCERT_Dashboard.0b7cd56b.svg";